import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Pathless layout for error pages (/403, /500).
 * Provides the minimal chrome: logo header + centred content area.
 * Individual error pages render inside <Outlet>.
 */
export const Route = createFileRoute('/_error')({
  component: ErrorLayout,
});

function ErrorLayout() {
  return (
    <div className='min-h-screen flex flex-col'>
      <header className='absolute px-8 py-10'>
        <img src='/dxc-logo.png' alt='DXC' className='h-8' width={195} height={39} />
      </header>
      <Outlet />
    </div>
  );
}
